<template>
    <div class="loading-owl">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 193.87 174.79">
            <defs />
            <title>owl-yellow</title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="OBJECTS">
                    <path
                        :fill="fill4"
                        class="cls-1"
                        d="M96.93,4.19c-36.2,0-75.24,29.65-67.43,87.7,6.37,47.32,27.68,77,67.43,77s61.07-29.65,67.43-77C172.17,33.84,133.13,4.19,96.93,4.19Z"
                    />
                    <path
                        :fill="fill6"
                        class="cls-2"
                        d="M96.93,91.5c-40,0-46.28,37.86-47,55.64,11.16,13.93,26.66,21.72,47,21.72s35.86-7.79,47-21.72C143.22,129.36,137,91.5,96.93,91.5Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M138.58,19.64A47.91,47.91,0,0,0,156,0S126.73,21.08,96.4,21.1,36.85,0,36.85,0a47.89,47.89,0,0,0,17.6,19.79,35.49,35.49,0,1,0,42.48,34.8h0a35.49,35.49,0,1,0,41.65-34.95Z"
                    />
                    <circle
                        class="cls-4"
                        cx="61.79"
                        cy="54.59"
                        r="26.44"
                        transform="translate(-16.37 28.33) rotate(-22.89)"
                    />
                    <circle
                        class="cls-4"
                        cx="132.07"
                        cy="54.59"
                        r="26.44"
                        transform="translate(-10.83 55.67) rotate(-22.89)"
                    />
                    <circle
                        class="left-eye cls-5"
                        cx="61.79"
                        cy="54.59"
                        r="14.02"
                        transform="translate(-20.5 59.68) rotate(-45)"
                    />
                    <circle class="cls-4" cx="57.98" cy="45.62" r="5.06" />
                    <path
                        class="cls-4"
                        d="M70.36,63.55a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,70.36,63.55Z"
                    />
                    <circle
                        class="cls-5"
                        cx="132.07"
                        cy="54.59"
                        r="9.88"
                        transform="translate(0.09 109.38) rotate(-45)"
                    />
                    <path
                        class="cls-4"
                        d="M133,48.27a3.57,3.57,0,1,1-3.56-3.57A3.56,3.56,0,0,1,133,48.27Z"
                    />
                    <path
                        class="cls-4"
                        d="M138.11,60.9a1.6,1.6,0,1,1-1.59-1.59A1.6,1.6,0,0,1,138.11,60.9Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M74.89,112.08h6.6S78.52,120.24,74.89,112.08Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M81.49,112.08H88.1S85.12,120.24,81.49,112.08Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M88.1,112.08h6.6S91.73,120.24,88.1,112.08Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M94.7,112.08h6.6S98.33,120.24,94.7,112.08Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M101.3,112.08h6.6S104.93,120.24,101.3,112.08Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M107.9,112.08h6.6S111.53,120.24,107.9,112.08Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M114.5,112.08h6.6S118.13,120.24,114.5,112.08Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M61.69,121.66h6.6S65.32,129.82,61.69,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M68.29,121.66h6.6S71.92,129.82,68.29,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M74.89,121.66h6.6S78.52,129.82,74.89,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M81.49,121.66H88.1S85.12,129.82,81.49,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M88.1,121.66h6.6S91.73,129.82,88.1,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M94.7,121.66h6.6S98.33,129.82,94.7,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M101.3,121.66h6.6S104.93,129.82,101.3,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M107.9,121.66h6.6S111.53,129.82,107.9,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M114.5,121.66h6.6S118.13,129.82,114.5,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M121.1,121.66h6.61S124.73,129.82,121.1,121.66Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M127.71,121.66h6.6S131.34,129.82,127.71,121.66Z"
                    />
                    <path :fill="fill7" class="cls-3" d="M61.69,132h6.6S65.32,140.12,61.69,132Z" />
                    <path :fill="fill7" class="cls-3" d="M68.29,132h6.6S71.92,140.12,68.29,132Z" />
                    <path :fill="fill7" class="cls-3" d="M74.89,132h6.6S78.52,140.12,74.89,132Z" />
                    <path :fill="fill7" class="cls-3" d="M81.49,132H88.1S85.12,140.12,81.49,132Z" />
                    <path :fill="fill7" class="cls-3" d="M88.1,132h6.6S91.73,140.12,88.1,132Z" />
                    <path :fill="fill7" class="cls-3" d="M94.7,132h6.6S98.33,140.12,94.7,132Z" />
                    <path :fill="fill7" class="cls-3" d="M101.3,132h6.6S104.93,140.12,101.3,132Z" />
                    <path :fill="fill7" class="cls-3" d="M107.9,132h6.6S111.53,140.12,107.9,132Z" />
                    <path :fill="fill7" class="cls-3" d="M114.5,132h6.6S118.13,140.12,114.5,132Z" />
                    <path :fill="fill7" class="cls-3" d="M121.1,132h6.61S124.73,140.12,121.1,132Z" />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M127.71,132h6.6S131.34,140.12,127.71,132Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M68.29,142.25h6.6S71.92,150.41,68.29,142.25Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M74.89,142.25h6.6S78.52,150.41,74.89,142.25Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M81.49,142.25H88.1S85.12,150.41,81.49,142.25Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M88.1,142.25h6.6S91.73,150.41,88.1,142.25Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M94.7,142.25h6.6S98.33,150.41,94.7,142.25Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M101.3,142.25h6.6S104.93,150.41,101.3,142.25Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M107.9,142.25h6.6S111.53,150.41,107.9,142.25Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M114.5,142.25h6.6S118.13,150.41,114.5,142.25Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M121.1,142.25h6.61S124.73,150.41,121.1,142.25Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M74.89,152.54h6.6S78.52,160.7,74.89,152.54Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M81.49,152.54H88.1S85.12,160.7,81.49,152.54Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M88.1,152.54h6.6S91.73,160.7,88.1,152.54Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M94.7,152.54h6.6S98.33,160.7,94.7,152.54Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M101.3,152.54h6.6S104.93,160.7,101.3,152.54Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M107.9,152.54h6.6S111.53,160.7,107.9,152.54Z"
                    />
                    <path
                        :fill="fill7"
                        class="cls-3"
                        d="M114.5,152.54h6.6S118.13,160.7,114.5,152.54Z"
                    />
                    <polygon
                        class="cls-6"
                        points="96.93 67.63 88.58 76.24 96.93 88.39 105.29 76.24 96.93 67.63"
                    />
                    <path
                        class="cls-7"
                        d="M68.88,157.62c-4.4,0-8.21,5.85-8.21,11.31s4.75,4.39,5.54,2.66c0,0,.14,3.2,2.67,3.2s2.66-3.2,2.66-3.2c.8,1.73,5.54,2.8,5.54-2.66S73.27,157.62,68.88,157.62Z"
                    />
                    <path
                        class="cls-7"
                        d="M125,157.62c-4.39,0-8.2,5.85-8.2,11.31s4.74,4.39,5.54,2.66c0,0,.13,3.2,2.66,3.2s2.66-3.2,2.66-3.2c.8,1.73,5.54,2.8,5.54-2.66S129.38,157.62,125,157.62Z"
                    />
                    <path
                        class="left-wing cls-3"
                        :fill="fill7"
                        d="M154.21,90.39c10.88-6.07,24.63,2.11,39.66,31.27,0,0-11.72,2.4-16.23-4,0,0-6.49,8.93-12.55,0,0,0-12.24,4.27-17.15-5.63C144.59,105.31,146.3,94.81,154.21,90.39Z"
                    />
                    <path
                        class="right-wing cls-3"
                        :fill="fill7"
                        d="M39.66,90.39C28.78,84.32,15,92.5,0,121.66c0,0,11.72,2.4,16.22-4,0,0,6.5,8.93,12.56,0,0,0,12.24,4.27,17.14-5.63C49.27,105.31,47.57,94.81,39.66,90.39Z"
                    />
                </g>
            </g>
        </svg>
        <div class="loading-text">Loading...</div>
    </div>
</template>

<script>
import ColorHash from "color-hash";
import moment from "moment";
export default {
    name: "Avatar",
    props: ["userHash"],
    data: function() {
        var colorHashBody = new ColorHash({ saturation: 0.8 });
        var colorHashHead = new ColorHash({ saturation: 0.3 });
        var colorHashThree = new ColorHash({ saturation: 0.8 });

        let hashVal = this.userHash;

        return {
            fill1: "#1b1513",
            fill2: "#59341e",
            fill3: "#474136",
            fill4: colorHashHead.hex(hashVal + "asdasd"), // top,
            fill5: colorHashBody.hex(hashVal + "03274083274028357032"), // bow,
            fill6: colorHashBody.hex(hashVal), // body    ,
            fill7: colorHashThree.hex(hashVal),
            fill8: "#f1f1f0"
        };
    },
    watch: {
        userHash: function(val) {
            var colorHashBody = new ColorHash({ saturation: 0.8 });
            var colorHashHead = new ColorHash({ saturation: 0.3 });
            var colorHashThree = new ColorHash({ saturation: 0.5 });

            let hashVal = this.userHash;
            this.fill4 = colorHashHead.hex(val); // top
            this.fill5 = colorHashBody.hex(val + "03274083274028357032"); // bow
            this.fill6 = colorHashBody.hex(val); // body    },
            this.fill7 = colorHashThree.hex(val); // body    },
        }
    }
};
</script>

<style lang="scss" scoped>
svg {
    width: 100px;
    margin: auto;
}
.loading-text {
    font-family: $header-font;
    font-size: 25px;
}
.cls-1 {
    fill: #f9ec31;
}
.cls-2 {
    fill: #f5f097;
}
.cls-3 {
    fill: #f3cc35;
}
.cls-4 {
    fill: #fff;
}
.cls-5 {
    fill: #404041;
}
.cls-6 {
    fill: #f6921e;
}
.cls-7 {
    fill: #faaf40;
}

.left-wing {
    transform-box: fill-box;
    transform-origin: left;
    animation: flap-left-wing 2s infinite forwards;
}

.right-wing {
    transform-box: fill-box;
    transform-origin: right;
    animation: flap-right-wing 2s infinite forwards;
}

.left-eye {
    animation: move-left-eye 2s infinite forwards;
}

svg {
    animation: fly-up-down 2s infinite forwards;
}

@keyframes fly-up-down {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-0.4rem);
    }
    100% {
        transform: translateY(0);
    }
}

@keyframes flap-right-wing {
    0% {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(20deg);
    }
    100% {
        transform: rotate(0deg);
    }
}

@keyframes flap-left-wing {
    0% {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(-20deg);
    }
    100% {
        transform: rotate(0deg);
    }
}

@keyframes move-left-eye {
    0% {
        transform: translateX(0);
    }
    30% {
        transform: translateX(2px);
    }
    100% {
        transform: translateX(0);
    }
}
</style>
